<template>
    <div>
        <div :style="{ top: `${contextMenuPos.yPos}px`, left: `${contextMenuPos.xPos}px` }" class="contextMenu">
            <div v-if="this.playerLoop && this.getSkinInfos.action_loop" class="option" v-on:click="toggleRepeat">
                <div class="repeatItem">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16">
                        <g fill="none" fill-rule="evenodd">
                            <g fill="#787878">
                                <g>
                                    <g>
                                        <path
                                            d="M12.35 8c.333 0 .608.257.646.589l.004.078V10c0 1.793-1.38 3.255-3.109 3.33l-.141.003H2.22l1.49 1.529c.234.24.252.618.054.88l-.054.063c-.235.24-.603.259-.858.055l-.062-.055-2.6-2.667c-.029-.03-.055-.062-.077-.095l-.044-.078-.025-.058-.026-.082-.015-.09L0 12.667l.003-.062.012-.08.026-.092.029-.068.018-.033c.019-.034.04-.065.064-.094l.038-.043 2.6-2.666c.254-.26.666-.26.92 0 .234.24.252.618.054.88l-.054.062L2.22 12h7.53c1.038 0 1.887-.833 1.947-1.882L11.7 10V8.667c0-.369.291-.667.65-.667zM10.148.14l.062.055 2.6 2.667c.03.031.057.064.08.1l.045.08.033.085.022.09.009.075.001.041-.003.067-.016.092-.007.03-.038.1-.026.05c-.018.032-.038.06-.06.088l-.04.045-2.6 2.666c-.254.26-.666.26-.92 0-.234-.24-.252-.618-.054-.88l.054-.062 1.49-1.53L3.25 4c-1.038 0-1.887.833-1.947 1.882L1.3 6v1.333c0 .369-.291.667-.65.667-.333 0-.608-.257-.646-.589L0 7.333V6c0-1.793 1.38-3.255 3.109-3.33l.141-.003h7.53L9.29 1.137c-.234-.24-.252-.618-.054-.88L9.29.195c.235-.24.603-.259.858-.055z"
                                            transform="translate(-556.000000, -389.000000) translate(543.000000, 377.000000) translate(13.000000, 12.000000)" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                    <span class="itemTitle" :style="{ marginLeft: '11px' }">
                        {{ $t('AllTraslation.repeat') }}
                    </span>

                    <span v-if="isRepeat" class="repeatCheckbox">&#x2714;</span>
                </div>
            </div>

            <div class="option" v-if="this.getSkinInfos.info_stats" @click="showStatsModal?.()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <g fill="none" fill-rule="evenodd">
                        <g fill="#787878">
                            <g>
                                <g>
                                    <path
                                        d="M.639 0c.32 0 .586.242.631.557l.007.096v11.09c0 1.98.752 2.885 2.419 2.947l.189.003h11.476c.353 0 .639.293.639.654 0 .328-.236.6-.544.646L15.36 16H3.885C1.433 16 .083 14.585.004 11.99L0 11.743V.653C0 .293.286 0 .639 0zm13.533 4.051c.26.188.34.537.205.82l-.053.091-2.41 3.482c-.284.39-.804.497-1.208.264l-.098-.066L7.61 6.37 5.357 9.648c-.183.265-.524.35-.8.212l-.09-.054c-.26-.187-.342-.536-.208-.819l.053-.091 2.457-3.574c.274-.398.791-.517 1.2-.294l.12.077 2.997 2.273 2.196-3.171c.204-.295.602-.364.89-.156z"
                                        transform="translate(-554.000000, -445.000000) translate(543.000000, 377.000000) translate(11.000000, 68.000000)" />
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <span class="itemTitle">{{ $t('AllTraslation.statistics') }}</span>
            </div>

            <div class="option">
                <a class="link"  target="_blank" rel="noreferrer"
                    href="https://www.empreinte.com/outils-visualiser/video-player/">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                        <g fill="none" fill-rule="evenodd">
                            <g fill="#787878">
                                <g>
                                    <g>
                                        <path
                                            d="M8 16c-2.137 0-4.146-.832-5.657-2.343C.833 12.146 0 10.137 0 8s.832-4.146 2.343-5.657C3.854.833 5.863 0 8 0s4.146.832 5.657 2.343C15.167 3.854 16 5.863 16 8s-.832 4.146-2.343 5.657C12.146 15.167 10.137 16 8 16zM8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm3.292 10.292l-.883-.883c-1.329 1.328-3.49 1.328-4.818 0-1.328-1.329-1.328-3.49 0-4.818 1.329-1.328 3.49-1.328 4.818 0l.883-.883c-1.815-1.816-4.77-1.816-6.584 0-1.816 1.815-1.816 4.77 0 6.584.907.908 2.1 1.362 3.292 1.362 1.192 0 2.385-.454 3.292-1.362z"
                                            transform="translate(-555.000000, -471.000000) translate(543.000000, 377.000000) translate(12.000000, 94.000000)" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </a>

                <a class="link" target="_blank" rel="noreferrer" href="https://www.empreinte.com/outils-visualiser/video-player/">
                    <span class="itemTitle">
                        {{ $t('AllTraslation.powered') }} <span :style="{ fontWeight: 600 }">Empreinte</span>
                    </span>
                </a>
            </div>

            <span class="disabled">UEP version 4.0</span>
        </div>

    </div>
</template>
    
<script >
import { defineComponent } from 'vue';
import en from '../../../i18n/en_US'
import fr from '../../../i18n/fr_FR'
import { mapGetters } from "vuex";

export default defineComponent({
    name: 'RightClickMenu',
    i18n: {
        messages: {
            en: en,
            fr: fr,
        },
    },
    props: {
        visible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        contextMenuPos: {
            type: Object,
            default() {
                return {
                    xPos: 0,
                    yPos: 0,
                }
            }
        },
        showStatsModal: {
            type: Function
        },
        playerLoop: {
            type: Function
        },
        isRepeat: {
            type: Boolean
        }
    },
    data() {
        return {
            toggleRepeat: () => {
                this.playerLoop?.();
            }
        }
    },
      computed: {
    ...mapGetters(["getSkinInfos"]),
  },
})
</script>
  
<style>
.contextMenu {
    width: 202px;
    height: fit-content;
    background-color: var(--vm-color-one-04);
    z-index: 99;
    box-shadow: 0 2px 3px 0 var(--vm-color-one-02);
    padding-top: 6px;
    opacity: 1;
    font-size: 14px;
    border-radius: 2px;
    padding: 5px 0 5px 0;
    margin: 0;
    position: absolute;
    transition: opacity 0.5s linear;
    position: fixed;
}

.contextMenu .option {
    font-size: 12px;
    text-decoration: none;
    padding-left: 13px;
    cursor: pointer;
    user-select: none;
    transition: 0.2s;
    position: relative;
    min-height: 28px;
    height: fit-content;
    color: var(--vm-color-three-08);
    display: flex;
    align-items: center;
    outline: none;
    cursor: default;
    margin-bottom: 1px;
    cursor: pointer;
}
.contextMenu .option svg {
  fill: var(--vm-color-three) !important;
}

.contextMenu .option svg path {
  fill: var(--vm-color-three) !important;
}
.contextMenu .option:hover {
    background: var(--vm-color-one-06);
}

.itemTitle {
    color: var(--vm-color-three-08);
    font-size: 12px;
    margin-left: 8px;
        display: flex;
    justify-content: space-between;
    gap: 2px;

}

.disabled {
    color: var(--vm-color-three-08);
    pointer-events: none;
    font-size: 12px;
    margin-left: 37px;
    height: 20px;
}

.link {
    text-decoration: unset;
}

.repeatCheckbox {
    font-size: 15px;
    position: absolute;
    right: 10px;
}

.repeatItem {
    display: flex;
    align-items: center;
}
</style>